module.exports = __webpack_public_path__ + "img/jsc.f5a998c9.svg";